import axios from "axios";

export const BASE_URL_INVOICE = "http://localhost:3003/";
export const AXIOS_INVOICE = axios.create({ baseURL: BASE_URL_INVOICE });
